import type { VenueDTO } from '@ui/shared/util-api';
import { MapItem } from '@ui/shared/util-map';

export class ProjectListItemModel extends MapItem {
    public readonly imagePath: string;
    public readonly thumbnailPath: string;
    public district: number;
    public ambience?: string | null;
    public area?: string | null;
    public poleCount?: number | null;
    public usableArea?: string | null;
    public restrictions?: string | null;
    public electricitySupply?: string | null;
    public waterSupply?: string | null;
    public nextPublicTransportStop?: string | null;
    public nextCarPark?: string | null;
    public links?: string | null;
    public specialUsageKinds: Array<string>;

    constructor(mapItem: VenueDTO) {
        super(mapItem);

        this.imagePath = mapItem.image?.thumbs?.detail ?? mapItem.image?.image ?? '';
        this.thumbnailPath = mapItem.image?.thumbs?.preview ?? this.imagePath;
        this.district = mapItem.district;
        this.ambience = mapItem.ambience;
        this.area = mapItem.area;
        this.poleCount = mapItem.pole_count;
        this.usableArea = mapItem.usable_area;
        this.restrictions = mapItem.restrictions;
        this.electricitySupply = mapItem.electricity_supply;
        this.waterSupply = mapItem.water_supply;
        this.nextPublicTransportStop = mapItem.next_public_transport_stop;
        this.nextCarPark = mapItem.next_car_park;
        this.links = mapItem.links;
        this.specialUsageKinds = mapItem.special_usage_kinds.map(item => item.name);

        this.iconPath = mapItem.icon ?? '';
        this.iconLabel = this.specialUsageKinds.length > 0 ? `Kategorie: ${ this.specialUsageKinds[0] }` : '';
    }
}
